// extracted by mini-css-extract-plugin
module.exports = {"attributionWindowModal":"AttributionWindowModal_attributionWindowModal__1WZmS","text":"AttributionWindowModal_text__BPyz-","button":"AttributionWindowModal_button__2Xe_j"};